import { activePoliciesListResponseMap } from '@/entities/Services/Renew/';

export const endpointRequestMap = {
  '/getactivepolicies': activePoliciesListResponseMap,
};
